import React, { useState } from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import WorkflowText from "./components/WorkflowText";
import WorkflowImage from "./components/WorkflowImage";

export default function App() {
  const [activeTab, setActiveTab] = useState("text");

  return (
    <div className="app">
      <div className="bg-grid" />
      <div className="bg-glow top-left" />
      <div className="bg-glow bottom-right" />

      <Navbar activeTab={activeTab} setActiveTab={setActiveTab} />

      <main className="main-content">
        <div className="page-header">
          {activeTab === "text" ? (
            <>
              <h1 className="page-title">
                Creative <span className="title-accent">Studio</span>
              </h1>
              <p className="page-desc">
                Turn a simple idea into a professional AI image in three steps
              </p>
            </>
          ) : (
            <>
              <h1 className="page-title">
                Style <span className="title-accent">Lab</span>
              </h1>
              <p className="page-desc">
                Upload any image — AI reverse-engineers its style and creates variations
              </p>
            </>
          )}
        </div>

        <div className="tab-content">
          {activeTab === "text" ? <WorkflowText /> : <WorkflowImage />}
        </div>
      </main>

      <footer className="footer">
        <span>Pear Media AI Studio</span>
        <span className="footer-dot">·</span>
        <span>Built with React + OpenAI / Gemini</span>
      </footer>
    </div>
  );
}
